import { render, staticRenderFns } from "./teacherDisplay.vue?vue&type=template&id=3762ad92&scoped=true&"
import script from "./teacherDisplay.vue?vue&type=script&lang=js&"
export * from "./teacherDisplay.vue?vue&type=script&lang=js&"
import style0 from "./teacherDisplay.vue?vue&type=style&index=0&id=3762ad92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3762ad92",
  null
  
)

export default component.exports